import { Vector3 } from 'three'

export default function findIntersection<T extends Vector3>(
  AStart: T,
  AEnd: T,
  BStart: T,
  BEnd: T,
) {
  const u = AEnd.clone().sub(AStart)
  const v = BEnd.clone().sub(BStart)
  const w = AStart.clone().sub(BStart)
  const a = u.dot(u)
  const b = u.dot(v)
  const c = v.dot(v)
  const d = u.dot(w)
  const e = v.dot(w)
  const D = a * c - b * b
  let sc, tc

  if (D < 1e-6) {
    sc = 0.0
    tc = b > c ? d / b : e / c
  } else {
    sc = (b * e - c * d) / D
    tc = (a * e - b * d) / D
  }

  const pointOnU = AStart.clone().add(u.multiplyScalar(sc))
  const pointOnV = BStart.clone().add(v.multiplyScalar(tc))

  return pointOnU.clone().add(pointOnV).multiplyScalar(0.5)
}
